import { Spinner } from "react-bootstrap";
import PropTypes from "prop-types";
import IconCheck from "../../layout/others/valid-check-icon.svg";
import "./styles.scss";

const DownloadStatusSpinner = ({
  downloadStatus,
  errorCaught,
  textPending,
  textDone
}) => {
  return (
    <div className="download-status-spinner">
      {downloadStatus === "downloading" ? (
        <>
          <Spinner variant="dark" animation="border" />
          <span>{textPending}</span>
        </>
      ) : (
        downloadStatus === "downloaded" &&
        errorCaught === false && (
          <span className="done">
            {textDone} <img src={IconCheck} alt="done-img" />
          </span>
        )
      )}
    </div>
  );
};

export default DownloadStatusSpinner;

DownloadStatusSpinner.propTypes = {
  downloadStatus: PropTypes.string.isRequired,
  errorCaught: PropTypes.bool.isRequired,
  textPending: PropTypes.string.isRequired,
  textDone: PropTypes.string.isRequired
};
